// extracted by mini-css-extract-plugin
export default {"EditableElement":"_EditableElement--BT5C5"};